var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:transparent;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 50,
    height: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 13.3,
    className: "st0",
    width: 15.6,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 13.3,
    className: "st0",
    width: 15.6,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 7,
    className: "st0",
    width: 3,
    height: 15.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 28.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -21.6677 20.5445)",
    className: "st0",
    width: 3,
    height: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 34.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -21.6627 20.5408)",
    className: "st0",
    width: 15.6,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 33.6,
    className: "st0",
    width: 15.6,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36,
    cy: 41,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36,
    cy: 29.1,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralMode);
export default __webpack_public_path__ + "static/media/general_mode.7428a62ff91b81a208566488aea63c67.svg";
export { ForwardRef as ReactComponent };